import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-target',
  templateUrl: './add-target.component.html',
  styleUrls: ['./add-target.component.scss']
})
export class AddTargetComponent implements OnInit {

  circlesList: any[] = [];
  blockList: any[] = [];
  financialYears: any[] = [];
  tableForm!: FormGroup;
  editIndex = true;
  showTable = false;
  targetForm!: FormGroup;
  targetData: any;
  UserDetails: any;
  isVisible: any;
  months: any
  get userFormArray(): FormArray {
    return this.tableForm.get('users') as FormArray;
  }
  rows: any[] = [];
  columns = [
    { prop: 'Months', name: 'Role', sortable: true },
    { prop: 'Target', name: 'First Name', sortable: true },

  ];
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      circleOffice: ['', Validators.required],

    });

    this.tableForm = this.fb.group({
      users: this.fb.array([])
    });
    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    switch (this.UserDetails?.roleId) {
      case 13:
        this.targetForm.addControl('blockOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));

        this.targetForm.removeControl('circleOffice')
        this.targetForm.get('blockOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.getTargetDetail();
            }
          });
        break;
      case 1:
        this.targetForm.get('circleOffice')?.valueChanges
          .pipe(skip(1)) // ignore the first emit
          .subscribe((val: any) => {
            if (this.targetForm.valid) {
              this.getTargetDetail();
            }
          });
        break;
      case 11:
        this.targetForm.addControl('blockOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));

        this.targetForm.controls['blockOffice'].disable();
        this.targetForm.removeControl('circleOffice')
        break;
      default:
    }


    this.targetForm.get('financialYear')?.valueChanges
      .pipe(debounceTime(300)).subscribe((val: any) => {
        const currentYear = new Date().getFullYear(); // e.g. 2025
        this.isVisible = (val?.startYear === currentYear);
        if (this.targetForm.valid) {
          this.getTargetDetail();
        }
      });
    this.getTargetCount();
  }
  allowOnlyInteger(event: any, maxLength: number) {
    let input = event.target.value;

    input = input.replace(/\D/g, '');

    input = input.replace(/^0+/, '');

    if (input === '0') {
      input = '';
    }

    if (input.length > maxLength) {
      input = input.substring(0, maxLength);
    }

    event.target.value = input;
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        this.circlesList = res.data.circles;
        this.blockList = res.data.blocks;
        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId)
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getTargetDetail() {


    if (this.targetForm.valid) {
      // 👉 You can send this.targetForm.value to your API here
      let obj = {
        "action": (this.UserDetails?.roleId == 1) ? 'GetTargetDetail' : 'GetBlockTargetDetail',
        ...(this.UserDetails?.roleId == 1, { "circleId": this.targetForm.getRawValue().circleOffice }),
        ...(this.UserDetails?.roleId == 13, { "blockId": this.targetForm.getRawValue().blockOffice, "circleId": this.UserDetails?.iCircleId }),
        "financialYear": this.targetForm.value?.financialYear?.financialYear
      }


      this.editIndex = false;
      this.targetData = null
      this.userFormArray.clear();
      this.rows = []
      this.reportService.getTargetDetail(obj).subscribe(res => {

        if (res && res?.data) {
          let data = res?.data?.targetDetails;
          this.months = res?.data?.adminData ? res?.data?.adminData : null;
          this.targetData = res?.data?.targetDetails;
          if (res)
            for (let index = 0; index < data.length; index++) {

              const formGroup = this.fb.group({

                year: [data[index].sMonthName + " " + data[index]?.financialYear],
                target: [data[index]?.targetValue ? data[index]?.targetValue : 0],
                iMonthId: [data[index]?.iMonthId],
                remainingTarget: [data[index]?.remainingTarget ? data[index]?.remainingTarget : 0],

              });

              this.userFormArray.push(formGroup);
              this.rows.push(formGroup)
            }


          this.showTable = true

        } else {
          this.targetData = null;
          this.showTable = false;
          this.toastService.showSuccess(res.message);
        }


      },
        (error: any) => {
          this.toastService.showError(error.message);
        }
      );
    } else {
      this.targetForm.markAllAsTouched(); // show validation errors
    }

  }
  editMode() {
    this.editIndex = !this.editIndex
  }
  editTarget() {
    let values: any = this.userFormArray.value
    let obj: any = {
      "action": (this.UserDetails?.roleId == 13) ? "AssignTargetToBI" : "AddTarget",
      "circleId": this.targetData[0]?.circleId,
      "financialYear": this.targetData[0]?.financialYear,
      ...(this.UserDetails?.roleId == 13, { "blockId": this.targetForm.value.blockOffice }),
      "aprilTarget": 0,
      "mayTarget": 0,
      "juneTarget": 0,
      "julyTarget": 0,
      "augustTarget": 0,
      "septemberTarget": 0,
      "octoberTarget": 0,
      "novemberTarget": 0,
      "decemberTarget": 0,
      "januaryTarget": 0,
      "februaryTarget": 0,
      "marchTarget": 0,
      // "createdBy": this.UserDetails?.id,
      // "modifiedBy":  this.UserDetails?.id
    }

    // Map month id to object keys
    const monthKeyMap: Record<number, string> = {
      1: 'aprilTarget',
      2: 'mayTarget',
      3: 'juneTarget',
      4: 'julyTarget',
      5: 'augustTarget',
      6: 'septemberTarget',
      7: 'octoberTarget',
      8: 'novemberTarget',
      9: 'decemberTarget',
      10: 'januaryTarget',
      11: 'februaryTarget',
      12: 'marchTarget',
    };

    // Fill values
    values.forEach((v: any, i: number) => {
      let key = monthKeyMap[v.iMonthId];
      if (!v?.target) {
        (this.userFormArray.at(i) as FormGroup).patchValue({
          target: 0
        });
      }
      if (key) {
        obj[key] = v.target;
      }
    });

    this.reportService.addTarget(obj).subscribe(res => {
      if (res) {

        let data = res?.data
        if (res?.status === 200) {
          this.toastService.showSuccess(res?.message);
        } else {
          this.toastService.showError(res?.message);
        }
        // for (let index = 0; index < this.targetData.length; index++) {

        //   const formGroup = this.fb.group({

        //     year: [data[index].sMonthName + " " + data[index]?.financialYear],
        //     target: [data[index]?.targetValue ? data[index]?.targetValue : 0],

        //   });

        //   this.userFormArray.push(formGroup);
        //   this.rows.push(formGroup)
        // }


        this.showTable = true
        this.editIndex = false
        this.getTargetDetail();

      }


    },
      (error: any) => {
        this.toastService.showError(error.message);
      }
    );


  }
}
